import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFF" stroke="#979593" strokeMiterlimit="10" d="M23.086 2.5H9.5a1 1 0 00-1 1v25a1 1 0 001 1h19a1 1 0 001-1V8.914a1 1 0 00-.293-.707l-5.414-5.414a1 1 0 00-.707-.293z"/>
        <path fill="none" stroke="#979593" strokeMiterlimit="10" d="M23.5 2.5v5a1 1 0 001 1h5"/>
        <path fill="#F5BA9D" d="M21 11a4 4 0 014 4h-4v-4z"/>
        <path fill="#C8C6C4" d="M25 16a5.006 5.006 0 01-6.076 4.888 4.975 4.975 0 01-3.812-3.812A5.006 5.006 0 0120 11v5h5zm1.5 8h-15a.5.5 0 100 1h15a.5.5 0 100-1zm0-2h-15a.5.5 0 100 1h15a.5.5 0 100-1z"/>
        <path fill="#C43E1C" d="M3.5 25h11a1.5 1.5 0 001.5-1.5v-11a1.5 1.5 0 00-1.5-1.5h-11A1.5 1.5 0 002 12.5v11A1.5 1.5 0 003.5 25z"/>
        <path fill="#FFF" d="M9.524 14.02c.921 0 1.625.214 2.115.64.488.427.733 1.045.733 1.854 0 .52-.116.986-.358 1.39-.241.405-.59.714-1.036.938-.446.225-.957.342-1.544.342H7.967L7.962 22h-1.18v-7.98h2.742zM7.962 18h1.615c.503 0 .885-.118 1.143-.353.258-.236.441-.655.441-1.108 0-.879-.548-1.539-1.537-1.539H7.962v3z"/>
    </svg>
)

export default class IconMSPowerPoint extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
